import { SIGNOUT_USER_SUCCESS } from '../User/UserTypes';
import { transformPremierlist } from '../../utils/premierLocationsHelper';
import * as TYPES from './PremierLocationsTypes';

const initialState = {
  list: null,
  premierLocationEventsList: [],
};

export default function premierLocationReducer(state = initialState, action) {
  const { type, payload } = action;
  if (type === TYPES.PREMIERLOCATION_LIST_SUCCESS) {
    return {
      ...state,
      list: payload,
      premierLocationEventsList: transformPremierlist(payload),
    };
  } else if (type === SIGNOUT_USER_SUCCESS) {
    return initialState;
  }
  return state;
}
